module.exports = __webpack_public_path__ + "img/fog-2.ab4ecd23.png";